import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const ContactListHeader = ({ 
  totalContacts = 0,
  selectedCount = 0,
  selectionMode = false,
  sortBy = 'name',
  onSortChange,
  onToggleSelectionMode,
  onSelectAll,
  onDeselectAll,
  onBulkDelete,
  onBulkExport,
  onBulkTag,
  className = ''
}) => {
  const sortOptions = [
    { value: 'name', label: 'Name (A-Z)' },
    { value: 'name-desc', label: 'Name (Z-A)' },
    { value: 'birthday', label: 'Birthday (Soon)' },
    { value: 'last-contact', label: 'Last Contact' },
    { value: 'created', label: 'Recently Added' },
    { value: 'company', label: 'Company' }
  ];

  return (
    <div className={`bg-surface border-b border-border ${className}`}>
      <div className="flex items-center justify-between p-4">
        {/* Left Section - Count & Selection */}
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <h2 className="text-lg font-semibold text-text-primary">
              Contacts
            </h2>
            <span className="text-sm text-text-secondary bg-muted px-2 py-1 rounded-full">
              {selectionMode ? `${selectedCount} selected` : `${totalContacts} total`}
            </span>
          </div>
          
          {selectionMode && (
            <div className="flex items-center space-x-2">
              <Button
                variant="outline"
                size="sm"
                onClick={selectedCount === totalContacts ? onDeselectAll : onSelectAll}
              >
                {selectedCount === totalContacts ? 'Deselect All' : 'Select All'}
              </Button>
            </div>
          )}
        </div>

        {/* Right Section - Actions & Sort */}
        <div className="flex items-center space-x-2">
          {selectionMode ? (
            // Bulk Actions
            <div className="flex items-center space-x-2">
              <Button
                variant="outline"
                size="sm"
                onClick={onBulkTag}
                disabled={selectedCount === 0}
                iconName="Tag"
                iconPosition="left"
              >
                Tag
              </Button>
              
              <Button
                variant="outline"
                size="sm"
                onClick={onBulkExport}
                disabled={selectedCount === 0}
                iconName="Download"
                iconPosition="left"
              >
                Export
              </Button>
              
              <Button
                variant="destructive"
                size="sm"
                onClick={onBulkDelete}
                disabled={selectedCount === 0}
                iconName="Trash2"
                iconPosition="left"
              >
                Delete
              </Button>
              
              <Button
                variant="ghost"
                size="sm"
                onClick={onToggleSelectionMode}
                iconName="X"
                iconPosition="left"
              >
                Cancel
              </Button>
            </div>
          ) : (
            // Normal Actions
            <div className="flex items-center space-x-2">
              {/* Sort Dropdown */}
              <div className="hidden md:block min-w-48">
                <Select
                  options={sortOptions}
                  value={sortBy}
                  onChange={onSortChange}
                  placeholder="Sort by..."
                />
              </div>
              
              {/* Mobile Sort Button */}
              <Button
                variant="outline"
                size="icon"
                className="md:hidden"
                onClick={() => {}}
              >
                <Icon name="ArrowUpDown" size={20} />
              </Button>
              
              {/* Selection Mode Toggle */}
              <Button
                variant="outline"
                size="sm"
                onClick={onToggleSelectionMode}
                iconName="CheckSquare"
                iconPosition="left"
                className="hidden sm:flex"
              >
                Select
              </Button>
              
              {/* Mobile Selection Toggle */}
              <Button
                variant="outline"
                size="icon"
                onClick={onToggleSelectionMode}
                className="sm:hidden"
              >
                <Icon name="CheckSquare" size={20} />
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactListHeader;